module.exports = __webpack_public_path__ + "static/media/salesforceHero.6295a3d1.png";